import React from 'react'
import { Button, Col, Row } from 'antd'
import SocialShare from '../SocialShare/SocialShare'
import Title from 'antd/es/typography/Title'
import styles from './CardModalFooter.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { setWindowNHQ } from '../../Slices/WindowNHQSlice'

type Props = {
  slug:any,
}


const CardModalFooter = (props: Props) => {

const {slug} = props;
  const {collectionUrl, id}:any = useSelector((state:any)=> state.modalData.data);
  const dispatch = useDispatch();


  
  return (
    <>
    <Col span={24}>
    <Row className={styles.modalFooterContainer} >
    <Col style={{display: "flex", justifyContent: "flex-start", alignItems: "center"}} xs={4} sm={2}>
      <Title style={{marginTop: 0}} level={5}>Share</Title>
    </Col>
    <Col xs={11} sm={14}>
      <SocialShare />
    </Col>
    <Col style={{display: "flex", justifyContent: "flex-end", alignItems: "center",}} xs={9} sm={8}><Link onClick={()=> dispatch(setWindowNHQ({id: id, type: 'collection', slug : slug}))} to={`/collection/${slug}`}><Button type='primary'>View Full</Button></Link></Col>
    </Row>
    </Col>
    </>
  )
}

export default CardModalFooter